import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { Menu } from './menu';
import { UserService } from '../../../auth/_services';
declare let mLayout: any;
@Component({
    selector: "app-aside-nav",
    templateUrl: "./aside-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class AsideNavComponent implements OnInit, AfterViewInit {
    listMenu: Menu[] = [


    ];

    constructor(userSession: UserService) {

        /*
        this.listMenu.push({
            url: "", type: 1, name: 'Utenti', icon: "fa-user",
            subMenu: [
                { url: "/utenti", type: 1, name: 'Gestione Utenti', icon: "m-menu__link-bullet--dot", subMenu: null },
            ]
        });
        */
        this.listMenu.push({
            url: "", type: 1, name: 'Test', icon: "fa-archive",
            subMenu: [
                { url: "/test", type: 1, name: 'Gestione Test', icon: "m-menu__link-bullet--dot", subMenu: null },
                { url: "/mail", type: 1, name: 'Gestione Email', icon: "m-menu__link-bullet--dot", subMenu: null },
                { url: "/utente", type: 2, name: 'Test Utente', icon: "m-menu__link-bullet--dot", subMenu: null }
            ]
        });

        this.listMenu.push({
            url: "", type: 1, name: 'Report', icon: "fa-bar-chart",
            subMenu: [
                { url: "/report", type: 1, name: 'Visualizza Report', icon: "m-menu__link-bullet--dot", subMenu: null }
            ]
        });



    }
    ngOnInit() {

    }
    ngAfterViewInit() {
        mLayout.initAside();
    }



}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.component.ts